module.exports = __webpack_public_path__ + "82b7a0a6128b0139c4e7ece71fdc9544.svg";